import React from "react"

import { ILinkList } from "../../../interfaces"
import CmsLink from "../cms-link"

class LinkList extends React.Component<ILinkList> {
  constructor(props) {
    super(props)
  }

  render() {
    if (this.props == null) return <div></div>

    const { links } = this.props
    return (
      <div className="cms-link-list">
        {links.map((link) => (
          <CmsLink link={link} key={link.id} />
        ))}
      </div>
    )
  }
}

export default LinkList
